import { render } from "./HeaderPage.vue?vue&type=template&id=c9fbf8c6"
import script from "./HeaderPage.vue?vue&type=script&lang=js"
export * from "./HeaderPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__